var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{attrs:{"variant":"neutral"},scopedSlots:_vm._u([(_vm.glSlots().default)?{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }